"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Utils = require("player-core/utils");
require("./Dialog.css");
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this._onClose = _this._onClose.bind(_this);
        _this._escHandler = _this._escHandler.bind(_this);
        _this._dialogID = _this.props.id || "dialog_" + Utils.createUUID();
        return _this;
    }
    Dialog.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isVisible && !prevProps.isVisible) {
            this.refDialog.focus();
            window.addEventListener('keydown', this._escHandler);
            Utils.addNoScroll();
        }
        else if (!this.props.isVisible && prevProps.isVisible) {
            window.removeEventListener('keydown', this._escHandler);
            Utils.removeNoScroll();
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this._escHandler);
    };
    Dialog.prototype._onClose = function () {
        this.props.onClose && this.props.onClose(this.props.id);
    };
    Dialog.prototype._escHandler = function (e) {
        if (e.keyCode === 27) {
            this._onClose();
        }
    };
    Dialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, isVisible = _a.isVisible, children = _a.children, footer = _a.footer, useCustomFooter = _a.useCustomFooter, tag = _a.tag, canClickOut = _a.canClickOut, onRef = _a.onRef;
        var cssDialog = ['p-dialog'];
        var propsDialog = {};
        if (isVisible)
            cssDialog.push('is-visible');
        propsDialog = {
            ref: function (r) {
                onRef && onRef(r);
                _this.refDialog = r;
            },
            'tabIndex': 0,
            'className': cssDialog.join(' '),
            'role': 'alertdialog',
            'aria-label': title,
            'aria-describedby': this._dialogID,
            'aria-modal': true,
        };
        var cssFooter = ['content-foot'];
        if (useCustomFooter)
            cssFooter.push('custom');
        return (React.createElement("div", __assign({}, propsDialog, { "data-tag": tag }),
            React.createElement("div", { className: "background", onClick: canClickOut && this._onClose }),
            React.createElement("div", { className: "content", id: this._dialogID },
                React.createElement("section", { className: "content-body" }, children),
                React.createElement("footer", { className: cssFooter.join(' ') }, footer))));
    };
    return Dialog;
}(React.Component));
Dialog.defaultProps = {
    id: '',
    title: '',
    isVisible: true,
    children: [],
    footer: [],
    useCustomFooter: false,
    tag: null,
    onClose: void (0),
    onRef: void (0),
    canClickOut: true,
};
exports.Dialog = Dialog;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-controls'])
        csod.engine.controls['common-controls'] = {};
    csod.engine.controls['common-controls']['Dialog'] = Dialog;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Dialog"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/Dialog/index.js
// module id = 955
// module chunks = 0